var Slot = /** @class */ (function () {
    function Slot() {
    }
    return Slot;
}());
export { Slot };
